import React from "react";
import dataEn from "../../../languages/en/sixSec";
import dataTh from "../../../languages/th//sixSec";
import { useNavigate } from "react-router-dom";

function SixthSection({ language }) {
  const navigate = useNavigate();
  const data = language === "en" ? dataEn : dataTh;

  return (
    <div
      className="h-600  
    bg-gradient-to-r from-[#0070F2] to-[#4B48E5] mb-12 overflow-hidden
    lg:h-700
    xl:h-900
    "
    >
      <section
        className="relative flex w-full flex-wrap 
    h-screen
    "
      >
        {/* <!-- First section on the right --> */}
        <div className="flex flex-col w-full overflow-hidden md:w-1/2">
          {/* <!-- Top left image --> */}
          <div className="absolute w-full h-full object-cover">
            <img
              src="https://i.ibb.co/sgxDNCH/tik.png"
              alt="tik-tok"
              className="absolute  w-72  top-0 -left-40 rotate-45
            md:w-500 md:-left-40 md:-top-42 md:rotate-35
            lg:w-600 lg:-left-56 lg:-top-20
            xl:w-700 xl:-left-56 xl:top-6"
            />

            <img
              src="https://i.ibb.co/0JGr4NF/ig.png"
              alt="ig"
              className="absolute -top-20 left-6 w-80  rotate-45
            md:w-500 md:-top-60 md:left-40 md:rotate-35
            lg:w-600 lg:left-28 lg:-top-60
             xl:w-700 xl:left-48 xl:-top-60"
            />

            <img
              src="https://i.ibb.co/1dgyMNG/fb.png"
              alt="facebook"
              className="absolute top-40 -left-28 w-80  rotate-45
            md:w-500 md:top-40 md:left-4 md:rotate-35
                  lg:w-600 lg:-left-16 lg:top-60
             xl:w-700 xl:-left-4 xl:top-80"
            />
          </div>
        </div>

        {/* <!-- Second section on the left --> */}
        <div
          className="absolute top-40 right-4  
          lg:top-32 lg:right-12 
          "
        >
          {/* <!-- Title --> */}
          <h2
            className="text-2xl font-bold mb-4 text-white text-center
        md:text-3xl md:mb-8
        lg:text-6xl
        lg:text-left lg:mb-8 lg:leading-normal
         "
          >
            {data.titel1} <br />
            <span className="text-gray-100 font-thin lg:text-4xl xl:text-4xl">
              {data.titel2}
            </span>
          </h2>

          {/* <!-- Social media icons (Facebook, Instagram, TikTok) --> */}
          <div
            className="flex justify-start w-16 
        md:w-24
        lg:w-28 lg:justify-start lg:ml-8
        "
          >
            <img
              src={process.env.PUBLIC_URL + "/icons/facebook.png"}
              alt="Facebook"
            />
            <img
              src={process.env.PUBLIC_URL + "/icons/IG.png"}
              alt="Instagram"
            />
            <img
              src={process.env.PUBLIC_URL + "/icons/tik-tok.png"}
              alt="TikTok"
            />
          </div>

          {/* <!-- Description text --> */}
          <p
            className="text-sm mb-4 opacity-70 text-white  text-center
        md:text-base md:mb-8
        lg:text-left lg:mb-8 lg:leading-8 lg:text-2xl
        "
          >
            {data.p1} <br /> {data.p2} <br /> {data.p3} <br /> {data.p4}
          </p>

          {/* <!-- Subscribe button --> */}
          <button
            className="text-primary-900 bg-white py-2 px-4 rounded-full font-bold text-sm mt-2
        md:text-base md:py-3 md:px-6 md:mt-4
        lg:text-lg lg:py-3 lg:px-6 lg:mt-4
        "
            onClick={() => navigate("/register")}
          >
            {data.btn}
          </button>
        </div>
      </section>
    </div>
  );
}

export default SixthSection;
